import { ContentEditor, Carousel, Heading } from '~/components'

interface TestimonialsProps {
  content: any
  slides?: Array<{ person: string; quote: string; role: string }>
}

export default function Testimonials({ content, slides }: TestimonialsProps) {
  return (
    <div className="container px-8 lg:px-16">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        <div className="slide-from-bottom md:col-span-1">
          <ContentEditor content={content} />
        </div>
        <div className="md:col-span-2">
          {slides && slides.length > 0 && (
            <Carousel
              classNames={{
                wrapper: 'overflow-hidden relative pb-6',
                container: 'w-full flex-row mb-10',
                dots: 'justify-evenly px-16 -translate-y-5',
                dot: 'h-0.5 flex-1',
                dotColor: 'teal',
                dotActiveColor: 'gold',
                arrowPrev:
                  'absolute z-10 bottom-0 left-0 p-2 h-10 w-10 flex items-center justify-center text-white bg-gold-500',
                arrowNext:
                  'absolute z-10 bottom-0 right-0 p-2 h-10 w-10 flex items-center justify-center text-white bg-gold-500',
              }}
              options={{ loop: true }}
              auto
              fade
              dots
              arrows
            >
              {slides.map((e, i) => (
                <Carousel.Slide key={i}>
                  <div className="lg:w-10/12">
                    <Heading
                      tag="h2"
                      size="h2"
                      bold={false}
                      className="text-teal-800"
                    >
                      “{e.quote}”
                    </Heading>
                    <p className="text-xs">
                      {e.person}, {e.role}
                    </p>
                  </div>
                </Carousel.Slide>
              ))}
            </Carousel>
          )}
        </div>
      </div>
    </div>
  )
}
